import Button from './Button'

type IssuesSummaryDto = {
  unresolvedCount: number,
  projectName: string
}

const IssuesSummary = (data: IssuesSummaryDto) => {
  return (
    <div className="">
      <div className="flex flex-wrap mx-[-15px]">
        <div className="flex-1 max-w-full px-4">
          <div className="mx-0 mb-1">
            <p className="text-sm md:text-xl mb-4 font-normal leading-6 text-gray-800 text-left">
              <span className='text-red-600 text-bold bg-white'>{data.unresolvedCount}</span> unresolved issues in
            </p>
          </div>
          <h2 className="font-bold text-xl md:text-2xl pb-4 leading-10 text-blue-900 opacity-100">
            {data.projectName}
          </h2>

          <div className="my-2.5 mb-6 font-normal text-xs leading-4 text-white uppercase">
            Explore next steps
          </div>

          <div className="flex items-center gap-5">
            <Button
              text="View all issues"
              shade="dark"
              buttonType="default"
              type="button"
              size="small"
              className="w-max gap-2 text-black md:text-sm text-xs"
              link="/issue-management"
            />

            <Button
              text="Call supervisor"
              shade="dark"
              buttonType="secondary"
              type="button"
              size="small"
              className="w-max gap-2 text-white md:text-sm text-xs"
            />

            {/* <Button
              text="Call Agent"
              shade="dark"
              buttonType="default"
              type="button"
              size="small"
              className="w-max gap-2 text-black md:text-sm text-xs"
            /> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default IssuesSummary
